export function lazyLoadComponent(componentName) {
    return () => import(`@/layouts/${componentName}/${componentName}.vue`); // /src/layouts/folder/component.vue
}
